import { render } from "./ProfitAndLossStructure.vue?vue&type=template&id=04ea7db0&scoped=true"
import script from "./ProfitAndLossStructure.vue?vue&type=script&lang=js"
export * from "./ProfitAndLossStructure.vue?vue&type=script&lang=js"

import "./ProfitAndLossStructure.vue?vue&type=style&index=0&id=04ea7db0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ea7db0"]])

export default __exports__